import { render, staticRenderFns } from "./diaChangePassword.vue?vue&type=template&id=8663dcbe"
import script from "./diaChangePassword.vue?vue&type=script&lang=js"
export * from "./diaChangePassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports